import React = require('react');
import {IProileComp} from "../../interfaces/layout/blocks/IUser";
export interface IProfileItemCompProps extends IProileComp {
    onClick: Function;
	listMode?:boolean;
    index?:number;
}

interface IProfileItemCompState {
}

export class ProfileItemCompForList extends React.Component<IProfileItemCompProps, IProfileItemCompState>{

    constructor(props:IProfileItemCompProps){
        super(props);
    }

    render() {
		var classNames:string = 'item profileForListComp';
		if ( this.props.currentUser === true ) {
			classNames += ' current_user';
		}
		var listMode:boolean = false;
		if ( this.props.listMode !== undefined && this.props.listMode === true ) {
			listMode = true;
			classNames += ' list_mode';
		}

		if ( this.props.coupleBefore !== undefined && this.props.coupleBefore === true ) {
			classNames += ' couple_before';
		}

		if ( this.props.coupleAfter !== undefined && this.props.coupleAfter === true ) {
			classNames += ' couple_after';
            if ( this.props.index !== undefined ) {
                var index:number = this.props.index +1;
                if ( index % 3 === 0 ) {
                    classNames += ' break';
                }
            }
		}
        var name:string = this.props.name;
        if ( this.props.birthName !== '' ) {
            name = this.props.birthName;
        }
        return (
			<div className={classNames}>
				{ listMode === true ? <div className="title">
                        <h2>{ this.props.affinity===''?'SAJÁT PROFILOM':this.props.affinity }</h2>
					</div>: '' }
                <div className="bg"></div>
				<a className="info" onClick= { e => this.props.onClick(e, this.props.id) }>
                    <h1>{ name }</h1>
                    <div className="img_box">
                        { this.props.img !== null?<img src={this.props.img} alt="" />:<img src="/img/default.png" height={95} alt="" /> }
                    </div>
					<div className="date_city">
    						{ this.props.birthDate !== '' ?<span>
    						   { this.props.birthDate }
    					   .</span>:''}
    					   { this.props.deathDate !== '' ?<span>
    						  - { this.props.deathDate }
    					  .</span>:''}
                          , { this.props.city !== ''?<span>
                              { this.props.city }
    					</span>:''}
                    </div>

                    <div className="prof_btn">
                        PROFIL MEGTEKINTÉSE
                    </div>
	            </a>
                <div className="lead_box">
                    { this.props.fatherId !== null?
                        <div className="box">
                            <div className="label">
                                apa:
                            </div>
                            <a onClick= { e => this.props.onClick(e, this.props.fatherId) }>{ this.props.fatherName }</a>

                        </div>
                    :'' }
                    { this.props.motherId !== null?
                        <div className="box">
                            <div className="label">
                                anya:
                            </div>
                            <a onClick= { e => this.props.onClick(e, this.props.motherId) }>{ this.props.motherName }</a>
                        </div>
                    :'' }
                </div>
			</div>

        );
    }
}



// WEBPACK FOOTER //
// ./components/ProfileItemCompForList.tsx